import * as classDataParser from "../lib/markup-parsers/class+data";
import * as leafletApi from "../lib/map-apis/leaflet";

const markup_parsers = {
    // "rdf": rdfParser,
    "class+data": classDataParser,
};

const map_apis = {
    // mapbox: mapboxApi,
    leaflet: leafletApi,
};

const map_api_default_test_order = [
    // "mapbox",
    "leaflet",
];

function refresh(maps) {
    console.log("TODO: refreshing");
}

export function mount(parser, api_selection = undefined) {
    if (!parser) {
        console.error("no parser specified");

        return undefined;
    }

    if (!markup_parsers.hasOwnProperty(parser)) {
        console.error("unknown parser: '" + parser + "'");

        return undefined;
    }

    // Search for a working map API.
    let map_api = undefined;

    for (const api of api_selection || map_api_default_test_order) {
        if (!map_apis.hasOwnProperty(api)) {
            console.warn("unknown map API: '" + api + "'");

            continue;
        }

        if (map_apis[api].test()) {
            map_api = map_apis[api];

            break;
        }
    }

    if (!map_api) {
        console.error("none of the tested map APIs worked");

        return undefined;
    }

    // Extract map definitions from markup.
    const maps = markup_parsers[parser].parse();

    if (!maps) {
        console.warn("the parser came up empty");

        return undefined;
    }

    const apis = {};

    // Mount the individual maps.
    for (const [ map_id, map ] of Object.entries(maps)) {
        const api = map_api.mount(map);

        if (!api) {
            console.error("failed to mount map with id '" + map_id + "'");

            continue;
        } else {
            apis[map_id] = api;
        }
    }

    return {
        apis,
        refresh: () => refresh(map_apis),
    };
}
